import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import './SupplyMonthlyCharts.css';

const fmtMonthLabel = (baseDt) => {
  const text = String(baseDt || '');
  if (!/^\d{4}-\d{2}/.test(text)) return text;
  return `'${text.slice(2, 4)}.${text.slice(5, 7)}`;
};

function MoveinSupplyChart({
  regionName,
  title,
  scope = 'sigungu',
  onScopeChange,
  data = [],
}) {
  const chartOption = useMemo(() => {
    const safeRows = Array.isArray(data) ? data : [];
    const labels = safeRows.map((row) => fmtMonthLabel(row?.baseDt));
    const households = safeRows.map((row) => Number(row?.moveinHouseholdCount || 0));
    const complexes = safeRows.map((row) => Number(row?.moveinComplexCount || 0));
    const maxHouseholds = households.length ? Math.max(...households) : 0;
    const maxComplexes = complexes.length ? Math.max(...complexes) : 0;

    return {
      animationDuration: 450,
      grid: {
        left: 46,
        right: 44,
        top: 30,
        bottom: 48,
        containLabel: true,
      },
      legend: {
        top: 0,
        left: 0,
        itemWidth: 10,
        itemHeight: 10,
        textStyle: { fontSize: 11, color: '#475569', fontWeight: 700 },
      },
      tooltip: {
        trigger: 'axis',
      },
      xAxis: {
        type: 'category',
        data: labels,
        axisTick: { show: false },
        axisLabel: { color: '#64748b', fontSize: 11, hideOverlap: true },
        axisLine: { lineStyle: { color: '#dce4ee' } },
      },
      yAxis: [
        {
          type: 'value',
          max: maxHouseholds > 0 ? undefined : 100,
          axisLabel: {
            color: '#64748b',
            formatter: (value) => {
              const num = Number(value || 0);
              if (num >= 10000) return `${(num / 10000).toFixed(1).replace(/\.0$/, '')}만`;
              if (num >= 1000) return `${(num / 1000).toFixed(1).replace(/\.0$/, '')}천`;
              return num.toLocaleString('ko-KR');
            },
          },
          splitLine: { lineStyle: { color: '#e8edf4' } },
        },
        {
          type: 'value',
          position: 'right',
          max: maxComplexes > 0 ? undefined : 10,
          axisLabel: { color: '#64748b' },
          splitLine: { show: false },
        },
      ],
      series: [
        {
          name: '입주 세대수',
          type: 'bar',
          yAxisIndex: 0,
          data: households,
          barWidth: 10,
          itemStyle: { color: '#62c7d5' },
        },
        {
          name: '단지수',
          type: 'line',
          yAxisIndex: 1,
          data: complexes,
          symbolSize: 4,
          smooth: true,
          lineStyle: { width: 2, color: '#2d6cdf' },
          itemStyle: { color: '#2d6cdf' },
        },
      ],
    };
  }, [data]);

  return (
    <section className="supply-monthly-card">
      <div className="supply-monthly-head">
        <h3>{title || `${regionName} 아파트 입주물량`}</h3>
        <div className="supply-monthly-scope">
          <button type="button" className={scope === 'sido' ? 'active' : ''} onClick={() => onScopeChange?.('sido')}>시/도</button>
          <button type="button" className={scope === 'sigungu' ? 'active' : ''} onClick={() => onScopeChange?.('sigungu')}>구</button>
        </div>
      </div>
      <div className="supply-monthly-unit">단위: 세대</div>
      <ReactECharts option={chartOption} style={{ width: '100%', height: '330px' }} notMerge lazyUpdate />
    </section>
  );
}

export default MoveinSupplyChart;
